export default __webpack_public_path__ + "static/media/InvestmentCase-01.7ec59522.jpg";